<template>
  <v-data-table
    :headers="headers"
    :items="formattedList"
    item-key="id"
    :page="page"
    :items-per-page.sync="itemsPerPage"
    hide-default-footer
    class="rounded-xl dashed-outlined"
  >
    <template #item.file="{item, index}">
      <v-btn
        v-if="item.eff_contract.is_auto"
        outlined
        small
        color="teal darken-3"
        class="rounded-xl"
        @click="$emit('open-auto-calculate-dialog', item.id)"
      >
        Рассчитан автоматически
        <v-icon right x-small>fa-mouse-pointer</v-icon>
      </v-btn>
      <v-chip
        v-else
        :href="item.file.link"
        target="_blank"
        class="text-truncate"
        style="max-width: 250px"
      >
        {{ item.file.filename }}
      </v-chip>
    </template>
    <template #item.actions="{ item }">
      <div v-if="!isReview" class="d-flex align-content-space-between">
        <template v-if="item.eff_contract.is_auto">
          <v-icon small color="teal darken-3">fa-calculator</v-icon>
        </template>
        <template v-else>
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                small
                @click="$emit('editDialog', item)"
                :disabled="isReview || !isDate"
              >
                <v-icon small>fa fa-edit</v-icon>
              </v-btn>
            </template>
            <span>Редактировать</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                small
                :disabled="isReview || !isDate"
                @click="$emit('deletePersonEffContract', item.id)"
              >
                <v-icon small>fa fa-trash</v-icon>
              </v-btn>
            </template>
            <span>Удалить</span>
          </v-tooltip>
        </template>
      </div>

      <div v-else class="text-center">
        <v-icon
          v-if="item.status === 'confirm'"
          size="20"
          color="teal darken-3"
        >
          fa fa-check-circle
        </v-icon>
        <eff-contract-teacher-remark-popup
          v-else-if="item.status === 'has_remark'"
          :content="commentContent(item)"
        />
        <v-icon
          v-else
          size="20"
        >
          fa-circle
        </v-icon>
      </div>

    </template>
    <template #no-data>
      Отсутствуют эффективные контракты
    </template>
    <template v-slot:footer>
      <v-divider/>
      <div class="py-4">
        <v-btn
          @click="$emit('openDialog')"
          color="teal darken-3"
          class="white--text rounded-xl"
          :disabled="isReview || !isDate"
        >
          <v-icon small left>fa fa-plus</v-icon>
          Добавить
        </v-btn>
      </div>
    </template>
  </v-data-table>
</template>

<script>

import EffContractServices from "../../../services/EffContract";
import _ from "lodash";
import {mapState} from "vuex";
import EffContractTeacherRemarkPopup from "./EffContractTeacherRemarkPopup.vue";

export default {
  name: "PathTableEffContract",
  components: {EffContractTeacherRemarkPopup},

  props: {
    listContracts: Array,
    isReview: Boolean,
    isDate: Boolean,
  },

  data() {
    return {
      itemsPerPage: 999,
      page: 1,
      headers: [
        {
          text: 'Наименование показателя',
          value: 'eff_contract.indicator_name',
          groupable: false,
          divider: true,
          sortable: false,
          width: '35%',
          class: "text-subtitle-1",
        },
        {
          text: 'Ед. измерения',
          value: 'eff_contract.units_measurement',
          groupable: false,
          sortable: false,
          width: "5%",
          class: "text-subtitle-1",
        },
        {
          text: 'План',
          value: 'eff_contract.plan',
          groupable: false,
          sortable: false,
          width: '10%',
          class: "text-subtitle-1",
        },
        {
          text: 'Факт',
          value: 'fact',
          groupable: false,
          sortable: false,
          width: '10%',
          class: "text-subtitle-1",
        },
        {
          text: 'Источник',
          value: 'file',
          groupable: false,
          sortable: false,
          width: '35%',
          divider: true,
          class: "text-subtitle-1",
        },
        {
          text: `${this.isReview ? 'Проверка' : 'Действие'}`,
          value: 'actions',
          sortable: false,
          width: '5%',
          class: "text-subtitle-1",
        },
      ],
    };
  },

  computed: {

    ...mapState({
      payloadOrder: state => state.effective_contract.payloadOrder
    }),
    formattedList() {
      let newList = _.cloneDeep(this.listContracts)
      const replacedContracts = EffContractServices.findPersonContractsDependentOnBid(newList);

      _.forEach(replacedContracts, (replaceContract)=> {
        EffContractServices.calculatePlanPersonEffConWithBid(
          newList,
          replaceContract,
          this.payloadOrder.bid,
          'plan'
        );
      });

      return newList
    },
  },

  methods: {
    commentContent(item) {
      const comments = item?.comments;

      if (_.isNil(comments)) return "Отсутствует комментарий";

      return comments[comments.length - 1].content;
    },
  }
}
</script>

<style scoped>

</style>